import { usePrint } from "@/hooks/usePrint";
import styles from "./PrintStatus.module.scss";
import { RiPrinterLine } from "@remixicon/react";

export const PrintStatus = () => {
  const { hasPrinter } = usePrint();

  if (!hasPrinter) {
    return null;
  }

  return (
    <div className={styles.printStatus}>
      <RiPrinterLine size={28} />
      <div className={styles.statusIndicator} />
    </div>
  );
};
